import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef
} from '@angular/core';
import {Router} from '@angular/router';
import {Constants} from '../../../../constants';
import {MatAccordion, MatExpansionPanel} from '@angular/material/expansion';
import {HomeAccordionService} from './home-accordion.service';
import {DateRangeModel} from '../../../../models/date-range.model';
import {Appointment} from '../../../../landing/models';
import {PatientService} from '../../../../modules/patient/patient.service';
import {UiService} from '../../../../services/ui.service';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {fromEvent, Subscription} from 'rxjs';
import {TemplatePortal} from '@angular/cdk/portal';
import {filter, take} from 'rxjs/operators';
import {TaskService} from '../../../../services/task.service';
import {TaskQueryModel} from '../../../../dialog/tasks/task-management-dialog/task-management-dialog.component';
import {AuthenticationService} from '../../../../modules/auth/services/authentication.service';
import {SystemTaskDataModel} from '../../../../models/messaging/system-task-data.model';
import {MessagingConstants} from '../../../../models/MessagingConstants';
import {MessagingService} from '../../../../services/messaging.service';
import { TASK_TYPE } from 'src/app/models/constants/task-type.model';
import {TDOTaskListService} from "../../../controls/tdo-task-list/tdo-task-list.service";

@Component({
  selector: 'app-home-accordion',
  templateUrl: './home-accordion.component.html',
  styleUrls: ['./home-accordion.component.scss']
})

export class HomeAccordionComponent implements OnInit {
  @ViewChild('ctxMenu') contextMenu: TemplateRef<any>;
  @ViewChild(MatAccordion) matAccordion: MatAccordion;
  @ViewChildren(MatExpansionPanel) expansionPanels: QueryList<MatExpansionPanel>;
  @ViewChild('schedDropdown') schedDropdown : MatExpansionPanel;
  @Input() isExpanded = true;
  @Output() actionCheckOut =  new EventEmitter();

  numTaskItems: number = 0;
  numRecentPatients: number = 0;
  schedulePanelOpenState: boolean = false;
  recentPatientPanelOpenState: boolean = false;
  isDateHovered = false;
  isRangeHovered = false;
  tasks: SystemTaskDataModel[] = [];
  callTasks: SystemTaskDataModel[] = [];
  reportTasks: SystemTaskDataModel[] = [];
  financeTasks: SystemTaskDataModel[] = [];
  messagingSubscription: any;

  isShowScheduleDoctorMenu: boolean = false;

  private overlayRef: OverlayRef | null;
  private sub: Subscription;
  isContextOpen = false;

  constructor(private router: Router, public homeAccordionService: HomeAccordionService,
              public patientService: PatientService, private uiService: UiService,
              private overlay: Overlay,
              private taskService: TaskService,
              private authService: AuthenticationService,
              private viewContainerRef: ViewContainerRef,
              private messagingService: MessagingService,
              private TaskListService: TDOTaskListService) { }

  ngOnInit(): void {
    this.init();

    this.messagingSubscription = this.messagingService.componentMessageCall.subscribe(
      response => {
        if (response.event === MessagingConstants.CHECKOUT_PATIENT_COMPLETED) {
          this.init();
        }
        else if (response.event === 'PATIENT_DELETED') {
          // Refresh recent patients when a patient is deleted
          this.refreshRecentPatients();
        }
      }
    );
  }

  parseJson(jsonString: string) {
    return JSON.parse(jsonString.replace(/'/g, '"'));
  }

  init(){
    this.homeAccordionService.loadScheduleAppointments();
    //this.homeAccordionService.loadPastAppointments();

    if(this.TaskListService.tasks.getValue().length === 0) {
        this.TaskListService.loadTaskList();
    }
  }

  onScheduleIconClick() {
    this.router.navigateByUrl('scheduler');
  }

  getDate() {
    // Show day of week after the date (Month Day, Weekday)
    // Using abbreviated day name (Mon, Tue, etc.) to save space
    return Constants.monthNamesAbbreviated[this.homeAccordionService.scheduleDate.month()] + ' ' + 
           this.homeAccordionService.scheduleDate.date() + ', ' +
           this.homeAccordionService.scheduleDate.format('ddd');
  }

  changeScheduleDate(isIncrementing: boolean, event: MouseEvent, isSchedulePanelOpen: boolean): void {
    if (isSchedulePanelOpen) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.homeAccordionService.changeScheduleDate(isIncrementing);
  }

  changePatientRange(isIncrementing: boolean, event: MouseEvent) {
    if (this.recentPatientPanelOpenState) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.homeAccordionService.changeRecentPatients(isIncrementing);
  }

  isDateToday() {
    const today = this.homeAccordionService.today.date();
    const selected = this.homeAccordionService.scheduleDate.date();
    const isToday = today === selected;
    return isToday;
  }

  isIncremented() {
    return this.homeAccordionService.apptPageIndex > 0;
  }

  getPatientRange() {
    return this.homeAccordionService.recentPatientRange;
  }

  onSelectDoctorForSchedule() {

  }

  onClickOutside() {
    for (const panel of this.expansionPanels) {
      panel.close();
    }
  }

  homeAccordionCloseRequest(){
    this.schedulePanelOpenState = false;
    this.schedDropdown.close();
  }
  
  checkedOutState(): void {
    this.schedulePanelOpenState = false; // Adjust the state
    if (this.schedDropdown) {
        this.schedDropdown.close(); // Safely close the dropdown if it's defined
    }
    setTimeout(() => {
        this.actionCheckOut.emit(); // Emit the action if needed
    }, 500); // Add delay if required for animations or transitions
}


closeAccordion(): void {
  this.schedulePanelOpenState = false; // Adjust the state to close the accordion
  if (this.schedDropdown) {
      this.schedDropdown.close(); // Safely close the dropdown if it exists
  }
  console.log('Accordion closed through accordionClose event');
}


  openSchedulerInNewWindow() {
    this.uiService.openSchedulerWindow();
  }

  onSchedulerContextOpen(event: MouseEvent) {
    this.openContext(event, this.contextMenu, null, true);
  }

  // Context menu
  // Context boilerplate
  openContext({x, y}: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
    this.isContextOpen = true;
    this.closeContext();
    x = x + 50;
    y = y - 20;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({x, y}).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, {$implicit: data}));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.isContextOpen = false;
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  removeItemTask(taskId: string) {
    const index: number = this.tasks.findIndex( x => x.SystemTaskId ===  taskId);
    this.tasks.splice(index, 1);
  }

  // Add a setter for recentPatientPanelOpenState to refresh patients when the panel opens
  set _recentPatientPanelOpenState(value: boolean) {
    this.recentPatientPanelOpenState = value;
    // No need to refresh here as the RecentPatientsComponent will handle it
  }

  // Method to refresh recent patients
  refreshRecentPatients() {
    if (this.authService && this.authService.currentUserValue) {
      const userId = this.authService.currentUserValue.authdata.userid;
      this.patientService.getRecentPatients(userId).subscribe();
    }
  }
}
